import { Resolution } from './types';

/**
 * https://www.tutorialspoint.com/dip/pixel_resolution.htm
 */
export const getMegaPixelCount = ({ width, height }: Resolution) => {
  return (width * height) / 1000000;
};
